import { render, staticRenderFns } from "./FormDesigner.vue?vue&type=template&id=3032d938&scoped=true"
import script from "./FormDesigner.vue?vue&type=script&lang=js"
export * from "./FormDesigner.vue?vue&type=script&lang=js"
import style0 from "./FormDesigner.vue?vue&type=style&index=0&id=3032d938&prod&scoped=true&lang=css"
import style1 from "./FormDesigner.vue?vue&type=style&index=1&id=3032d938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3032d938",
  null
  
)

export default component.exports